var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthoritiesLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.5,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9627 32.0795C33.4075 32.1975 34.861 32.0115 36.2295 31.5332C36.4425 28.9077 33.7335 27.0363 31.3533 28.1646C31.192 28.2411 31.0368 28.3301 30.8894 28.4309M31.9627 32.0795V32.1137C31.9627 32.3704 31.949 32.6236 31.9204 32.8733C29.8507 34.0608 27.5054 34.6839 25.1192 34.68C22.6442 34.68 20.3208 34.023 18.318 32.8733C18.2887 32.6094 18.2745 32.344 18.2757 32.0784M31.9627 32.0795C31.9582 30.7868 31.5859 29.5198 30.8894 28.4309M30.8894 28.4309C29.6328 26.46 27.4566 25.2687 25.1192 25.2703C22.7822 25.2691 20.6065 26.4615 19.3502 28.432M18.2757 32.0784C16.8313 32.2007 15.3786 32.0153 14.0112 31.5343C13.9968 31.3571 13.9963 31.179 14.0096 31.0017C14.2074 28.375 17.1744 26.9474 19.3502 28.432M18.2757 32.0784C18.2798 30.7858 18.654 29.5211 19.3502 28.432M28.5409 18.4268C28.5409 21.0609 25.6895 22.7072 23.4083 21.3902C22.3496 20.7789 21.6975 19.6493 21.6975 18.4268C21.6975 15.7928 24.5489 14.1465 26.8301 15.4635C27.8888 16.0748 28.5409 17.2044 28.5409 18.4268ZM35.3844 21.8485C35.3844 23.8241 33.2458 25.0588 31.5349 24.0711C30.7409 23.6126 30.2518 22.7654 30.2518 21.8485C30.2518 19.873 32.3904 18.6384 34.1013 19.6261C34.8953 20.0845 35.3844 20.9317 35.3844 21.8485ZM19.9867 21.8485C19.9867 23.8241 17.848 25.0588 16.1372 24.0711C15.3432 23.6126 14.8541 22.7654 14.8541 21.8485C14.8541 19.873 16.9926 18.6384 18.7034 19.6261C19.4975 20.0845 19.9867 20.9317 19.9867 21.8485Z",
    stroke: "#E1CE00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthoritiesLink);
export default __webpack_public_path__ + "static/media/authorities-link.4e1d1ce241dcf5973343dd984a47cb86.svg";
export { ForwardRef as ReactComponent };